import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApiRequestParams } from '../../schema'

type DeleteStageParams = OpalApiRequestParams<'DeleteStageV2'>

export const deleteStage = async ({
  params,
}: {
  params: DeleteStageParams
}) => {
  const url = new URL(
    `/workflows/v2/stages/${params.path.stage_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .delete(url.toString())
    .then((res) => res.data)
}
